import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 120000,
  withCredentials: true,
});

export async function fetchCountries() {
  const { data } = await api.get("/countries");
  return data;
}

export async function fetchCountry(slug) {
  const { data } = await api.get(`/countries/${slug}`);
  return data;
}

export async function sendExpertMessage(payload) {
  const { data } = await api.post("/chat/expert", payload);
  return data;
}

export async function fetchChatHistory(sessionId) {
  const { data } = await api.get(`/chat/expert/${sessionId}`);
  return data;
}

export async function exploreOptions(payload) {
  const { data } = await api.post("/explore", payload);
  return data;
}

export async function calculateBudget(payload) {
  const { data } = await api.post("/budget/calculate", payload);
  return data;
}

export async function realityCheck(payload) {
  const { data } = await api.post("/reality-check", payload);
  return data;
}

export async function fetchVisaCountries() {
  const { data } = await api.get("/visa/countries");
  return data.items || [];
}

export async function fetchVisaInfo(country_slugs) {
  const { data } = await api.post("/visa/info", { country_slugs });
  return data;
}

// ----- Forex -----
export async function fetchForexRates() {
  const { data } = await api.get("/forex/rates");
  return data;
}

export async function fetchForexCards() {
  const { data } = await api.get("/forex/cards");
  return data.items || [];
}

export async function fetchCashAdvice(countrySlug) {
  if (countrySlug) {
    const { data } = await api.get(`/forex/cash-advice/${countrySlug}`);
    return data;
  }
  const { data } = await api.get("/forex/cash-advice");
  return data.items || [];
}

export async function checkBargain(payload) {
  const { data } = await api.post("/forex/bargain-check", payload);
  return data;
}

// ----- Phrasebook -----
export async function fetchPhrasebookCountries() {
  const { data } = await api.get("/phrasebook/countries");
  return data.items || [];
}

export async function fetchPhrasebook(countrySlug) {
  const { data } = await api.get(`/phrasebook/${countrySlug}`);
  return data;
}


export async function generateItinerary(payload) {
  const { data } = await api.post("/itinerary/generate", payload);
  return data;
}

export function itineraryPdfUrl(id) {
  return `${API}/itinerary/${id}/pdf`;
}

export async function captureItineraryEmail(id, payload) {
  const { data } = await api.post(`/itinerary/${id}/email`, payload);
  return data;
}

export async function fetchItinerary(id) {
  const { data } = await api.get(`/itinerary/${id}`);
  return data;
}

export async function askItineraryAssistant(id, message, lang) {
  const { data } = await api.post(`/itinerary/${id}/assistant`, {
    message,
    lang,
  });
  return data; // { reply, changed, itinerary? }
}

// ----- Auth (Emergent Google) -----

export async function authMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function authExchangeSession(sessionId) {
  const { data } = await api.post("/auth/session", { session_id: sessionId });
  return data;
}

export async function authLogout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

export async function fetchMyItineraries() {
  const { data } = await api.get("/me/itineraries");
  return data.items || [];
}

export async function deleteMyItinerary(id) {
  const { data } = await api.delete(`/me/itineraries/${id}`);
  return data;
}

export async function toggleCountryFavorite(slug) {
  const { data } = await api.post(`/me/favorites/country/${slug}/toggle`);
  return data; // { favorited: bool }
}

export async function fetchMyFavorites() {
  const { data } = await api.get("/me/favorites");
  return data; // { countries: [] }
}

// ----- Travel Notes -----

export async function fetchMyNotes(itineraryId) {
  const { data } = await api.get("/me/notes", {
    params: itineraryId ? { itinerary_id: itineraryId } : {},
  });
  return data.items || [];
}

export async function createMyNote(payload) {
  const { data } = await api.post("/me/notes", payload);
  return data;
}

export async function updateMyNote(id, payload) {
  const { data } = await api.put(`/me/notes/${id}`, payload);
  return data;
}

export async function deleteMyNote(id) {
  const { data } = await api.delete(`/me/notes/${id}`);
  return data;
}


// ----- Activities (Klook / GetYourGuide / Agoda comparison) -----

export async function searchActivity(payload) {
  const { data } = await api.post("/activities/search", payload);
  return data;
}

export async function fetchCoupons() {
  const { data } = await api.get("/coupons");
  return data;
}


// ----- Public Blog -----

export async function fetchBlogPosts(page = 1, limit = 20) {
  const { data } = await api.get(`/blog?page=${page}&limit=${limit}`);
  return data;
}

export async function fetchBlogPost(slug) {
  const { data } = await api.get(`/blog/${slug}`);
  return data;
}
